<template>
  <div class="FileManager">
    <div class="Search">
      <input v-model="filter.search" class="Input"
        placeholder="搜索笔记" @input="GetDocTree">
      <div class="SidebarAction">
        <div class="ActionItem" @click="AddDocNode(0, 0)">
          <i class="iconfont icon-folder" style="font-size: 14px;"></i>
          <span>新建文件夹</span>
        </div>
        <div class="ActionItem" @click="AddDocNode(0, 1)">
          <i class="iconfont icon-markdown" style="font-size: 14px;"></i>
          <span>新建笔记</span>
        </div>
      </div>
    </div>
    <div class="FileList">
      <div style="position: absolute; width: 100%; height: calc(100% - 40px); z-index: 0;"
        v-contextmenu="{ name: 'FileListMenu', id: 0 }" data-area="list"
        @contextmenu="(event) => { OpenContextMenu(event, 0) }">
        <div v-if="fileList.length === 0"
          style="width: 100%; height: 100%; color: #515151; display: flex; justify-content: center;">
          <div style="padding-left: 18px; padding-top: 150px;">
            <i class="iconfont icon-zanwujilu" style="font-size: 80px;"></i>
            <div style="font-size: 14px; padding-top: 10px; padding-left: 3px;">暂无笔记</div>
          </div>
        </div>
      </div>
      <!-- 树形文件列表 -->
      <div style="position: absolute; z-index: 1; width: 100%; height: calc(100% - 40px); overflow-y: auto;">
        <TreeItem v-for="item in fileList" :key="item.id"
          :node="item"
          :current="currentUrlSlug"
          @click="HandleNodeClick"
          @node-move="HandleMoveNode"
          @contextmenu="OpenContextMenu">
        </TreeItem>
      </div>
      <!-- 底部回收站入口 -->
      <div class="RecycleBinEntry" 
        :class="{ 'RecycleBinEntry_DragOver': isDragOverRecycleBin }"
        @click="OpenRecycleBin"
        @dragover.prevent="HandleRecycleBinDragOver"
        @dragleave.prevent="isDragOverRecycleBin = false"
        @drop.prevent="HandleRecycleBinDrop">
        <img src="/icon/delete_bin.svg" style="width: 16px; height: 16px; margin-right: 8px;">
        <span>回收站</span>
      </div>
    </div>

    <!-- 右键菜单 - 文件列表 -->
    <context-menu name="FileListMenu">
      <context-menu-item v-for="(item, index) in filteredContextMenuList" :key="index"
        @itemClickHandle="(event) => { ContextMenuItemClick(event, item.name) }" :divider="item.divider">
        <div style="display: flex; align-items: center;">
          <img :src="item.icon" style="width: 20px;"/>
          <span style="padding: 0 10px;">{{ item.label }}</span>
        </div>
      </context-menu-item>
    </context-menu>
  </div>
</template>

<script>
import TreeItem from './TreeItem.vue'

export default {
  name: 'FileManager',
  components: { TreeItem },
  props: {
    currentUrlSlug: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isDragOverRecycleBin: false,
      filter: { search: '' },
      fileList: [],
      contextMenu: {
        currentNode: null,
        list: [
          {
            name: 'NewFolder',
            label: '新建文件夹',
            icon: '/icon/folder_new.svg',
            allow: ['list', 'folder'],
            divider: false
          },
          {
            name: 'NewNote',
            label: '新建笔记',
            icon: '/icon/markdown.svg',
            allow: ['list', 'folder'],
            divider: true
          },
          {
            name: 'Rename',
            label: '重命名',
            icon: '/icon/rename.svg',
            allow: ['folder', 'file'],
            divider: false
          },
          {
            name: 'Remove',
            label: '删除',
            icon: '/icon/delete_bin.svg',
            allow: ['folder', 'file'],
            divider: false
          }
        ]
      }
    }
  },
  computed: {
    filteredContextMenuList() {
      if (!this.contextMenu.currentNode) return []
      
      const node = this.contextMenu.currentNode
      const area = node.id === 0 ? 'list' : (node.type === 0 ? 'folder' : 'file')
      const urlSlug = node.urlSlug || ''

      return this.contextMenu.list.filter(item => {
        let allow = false
        if (item.allow.indexOf(area) > -1) allow = true
        if (item.allow.indexOf('id') > -1) {
          allow = (urlSlug !== '' && urlSlug === this.currentUrlSlug)
        }
        return allow
      })
    }
  },
  methods: {
    OpenContextMenu(event, node) {
      if (node === 0) {
        this.contextMenu.currentNode = { id: 0, type: -1, nodeName: '根目录' }
      } else {
        this.contextMenu.currentNode = node
      }
    },
    GetSortValue(node) {
      if (!node || node.sort === undefined || node.sort === null) return 100.0
      if (typeof node.sort === 'object') return parseFloat(node.sort.parsedValue) || 0
      return parseFloat(node.sort) || 0
    },
    HandleMoveNode({ sourceId, targetNode, position }) {
      if (sourceId === targetNode.id) return

      let targetParentId = 0
      let newSort = 100.0
      const BASE_STEP = 1000.0

      const findSiblings = (nodes, parentId) => {
        if (parentId === 0) return nodes
        for (const node of nodes) {
          if (node.id === parentId) return node.children || []
          if (node.children) {
            const found = findSiblings(node.children, parentId)
            if (found) return found
          }
        }
        return []
      }

      if (position === 'inside') {
        targetParentId = targetNode.id
        const siblings = targetNode.children || []
        if (siblings.length > 0) {
          // 放到子节点列表的最后面
          const lastChild = siblings[siblings.length - 1]
          newSort = this.GetSortValue(lastChild) + (BASE_STEP + Math.random() * 100)
        } else {
          newSort = BASE_STEP
        }
      } else {
        targetParentId = targetNode.parentId
        const siblings = findSiblings(this.fileList, targetParentId) || []
        const targetIndex = siblings.findIndex(s => s.id === targetNode.id)
        const targetSort = this.GetSortValue(targetNode)
        
        if (position === 'top') {
          const prevNode = siblings[targetIndex - 1]
          if (prevNode) {
            newSort = (targetSort + this.GetSortValue(prevNode)) / 2
          } else {
            newSort = targetSort - (BASE_STEP + Math.random() * 100)
          }
        } else {
          const nextNode = siblings[targetIndex + 1]
          if (nextNode) {
            newSort = (targetSort + this.GetSortValue(nextNode)) / 2
          } else {
            newSort = targetSort + (BASE_STEP + Math.random() * 100)
          }
        }
      }

      this.$Common.ApiList(this, 'DocTreeMove').then(url => {
        const payload = { id: sourceId, targetParentId: targetParentId, sort: newSort.toFixed(10) }
        this.$Common.SetLoading('正在移动节点...')
        this.axios.post(url, payload).then(res => {
          if (res.data.code === 200) {
            this.GetDocTree(false, false)
          } else {
            alert(res.data.message || '移动失败')
          }
          this.$Common.RemoveLoading()
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    ContextMenuItemClick(event, name) {
      const node = this.contextMenu.currentNode
      const id = node ? node.id : 0
      let nodeName = node ? node.nodeName : ''

      switch (name) {
        case 'NewFolder':
          this.AddDocNode(id, 0)
          break
        case 'NewNote':
          this.AddDocNode(id, 1)
          break
        case 'Rename':
          this.RenameDocNode(node)
          break
        case 'Tag':
          this.$emit('manage-tag', id)
          break
        case 'Remove':
          this.$emit('show-dialog', {
            title: '删除警告',
            content: '你正在删除 [' + nodeName + '], 删除后的节点会放入回收站，在30天内可恢复，是否继续?',
            icon: '/icon/warning.svg',
            buttonName: { accept: '继续删除', cancel: '再想想' },
            accept: () => { this.RemoveDocNode(id) }
          })
          break
        case 'CloseNote':
          this.$emit('close-note')
          break
        case 'Refresh':
          this.GetDocTree(true, true)
          break
        case 'OpenNote':
          this.GetNote(node.urlSlug)
          break
        case 'CleanSearch':
          this.CleanSearch()
          break
        case 'SaveNote':
          this.$emit('save-note', node.urlSlug)
          break
      }
    },
    HandleNodeClick(node) {
      if (node.type === 1) {
        this.GetNote(node.urlSlug)
      }
    },
    // 根据 urlSlug 查找树节点
    GetNodeByUrlSlug(urlSlug) {
      const findRecursive = (nodes) => {
        for (let node of nodes) {
          if (node.urlSlug === urlSlug) {
            return node
          }
          if (node.children && node.children.length > 0) {
            const found = findRecursive(node.children)
            if (found) return found
          }
        }
        return null
      }
      return findRecursive(this.fileList)
    },
    // 根据 urlSlug 实时更新树节点名称（仅本地更新，不请求后端）
    UpdateNodeNameByUrlSlug(urlSlug, newName) {
      const updateRecursive = (nodes) => {
        for (let node of nodes) {
          if (node.urlSlug === urlSlug) {
            node.nodeName = newName
            return true
          }
          if (node.children && node.children.length > 0) {
            if (updateRecursive(node.children)) return true
          }
        }
        return false
      }
      updateRecursive(this.fileList)
    },
    // 根据 urlSlug 实时更新树节点分享状态（仅本地更新）
    UpdateNodeShareStatusByUrlSlug(urlSlug, isShare) {
      const updateRecursive = (nodes) => {
        for (let node of nodes) {
          if (node.urlSlug === urlSlug) {
            node.isShare = isShare
            return true
          }
          if (node.children && node.children.length > 0) {
            if (updateRecursive(node.children)) return true
          }
        }
        return false
      }
      updateRecursive(this.fileList)
    },
    OpenRecycleBin() {
      if (this.$route.path !== '/Index/RecycleBin') {
        this.$router.push('/Index/RecycleBin')
      }
    },
    AddDocNode(parentId, type) {
      const typeName = type === 0 ? '文件夹' : '笔记'
      this.$emit('show-dialog', {
        name: 'Input',
        title: '新建' + typeName,
        placeholder: '请输入' + typeName + '名称',
        value: '新建' + typeName,
        icon: type === 0 ? '/icon/folder_new.svg' : '/icon/markdown.svg',
        buttonName: { accept: '创建', cancel: '取消' },
        accept: (name) => {
          if (!name) return
          this.ExecuteAddDocNode(parentId, type, name)
        }
      })
    },
    ExecuteAddDocNode(parentId, type, name) {
      let newSort = 1000.0
      const findChildren = (nodes, id) => {
        if (id === 0) return nodes
        for (const node of nodes) {
          if (node.id === id) return node.children || []
          if (node.children) {
            const found = findChildren(node.children, id)
            if (found) return found
          }
        }
        return []
      }
      const siblings = findChildren(this.fileList, parentId)
      if (siblings && siblings.length > 0) {
        const maxSort = Math.max(...siblings.map(s => this.GetSortValue(s)))
        newSort = maxSort + 1000.0
      }

      this.$Common.ApiList(this, 'DocTreeAdd').then(url => {
        const payload = {
          parentId: parentId,
          nodeName: name,
          type: type,
          sort: newSort.toFixed(10)
        }
        this.axios.post(url, payload).then(res => {
          const typeName = type === 0 ? '文件夹' : '笔记'
          if (res.data.code === 200) {
            this.GetDocTree(false, false)
            if (this.$Toast) this.$Toast('新建' + typeName + '成功', 'success')
          } else {
            if (this.$Toast) {
              this.$Toast(res.data.message || '新建' + typeName + '失败', 'error')
            } else {
              alert(res.data.message || '创建失败')
            }
          }
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    RenameDocNode(node) {
      this.$emit('show-dialog', {
        name: 'Input',
        title: '重命名',
        placeholder: '请输入新的名称',
        value: node.nodeName,
        icon: '/icon/rename.svg',
        buttonName: { accept: '确定', cancel: '取消' },
        accept: (newName) => {
           if (newName && newName !== node.nodeName) {
             this.ExecuteRenameDocNode(node, newName)
           }
        }
      })
    },
    ExecuteRenameDocNode(node, newName) {
      this.$Common.ApiList(this, 'DocTreeUpdate').then(url => {
        const payload = {
          id: node.id,
          nodeName: newName
        }
        this.$Common.SetLoading('正在重命名...')
        this.axios.post(url, payload).then(res => {
          if (res.data.code === 200) {
            this.GetDocTree(false, false)
          }
          this.$Common.RemoveLoading()
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    RemoveDocNode(id) {
      this.$Common.ApiList(this, 'DocTreeRemove').then(url => {
        this.$Common.SetLoading('正在删除...')
        this.axios.delete(url + '/' + id).then(res => {
          if (res.data.code === 200) {
            this.GetDocTree(false, false)
            this.$emit('node-removed', id)
            if (this.$Toast) this.$Toast('删除成功', 'success')
          } else {
             if (this.$Toast) {
               this.$Toast(res.data.message || '删除失败', 'error')
             } else {
               alert(res.data.message || '删除失败')
             }
          }
          this.$Common.RemoveLoading()
          this.$emit('close-dialog')
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    GetDocTree(errorState = true, loadingState = false) {
      if (loadingState) { this.$Common.SetLoading('正在获取文档列表...') }
      
      const isSearch = this.filter.search && this.filter.search.trim() !== ''
      const apiName = isSearch ? 'DocTreeSearch' : 'DocTreeList'

      this.$Common.ApiList(this, apiName).then(url => {
        let request
        if (isSearch) {
          request = this.axios.get(url, { params: { keyword: this.filter.search } })
        } else {
          request = this.axios.post(url, { search: '' })
        }

        request.then(res => {
          if (res.data.code === 200) {
            this.fileList = this.BuildTree(res.data.data)
          }
          this.$Common.RemoveLoading()
        }).catch(() => {
          this.$Common.RemoveLoading()
          if (errorState) { this.$Common.NetworkErrorDialog(this) }
        })
      })
    },
    BuildTree(data) {
      if (!data || !Array.isArray(data)) return []
      
      const map = {}
      const tree = []
      const flatList = []

      const flatten = (items) => {
        items.forEach(item => {
          const { children, ...rest } = item
          flatList.push(rest)
          if (children && children.length > 0) flatten(children)
        })
      }
      flatten(data)

      flatList.forEach(item => {
        const sortVal = this.GetSortValue(item)
        item.sort = { parsedValue: sortVal }
        map[item.id] = { ...item, children: [] }
      })

      flatList.forEach(item => {
        const node = map[item.id]
        if (item.parentId !== 0 && map[item.parentId]) {
          map[item.parentId].children.push(node)
        } else {
          if (item.parentId === 0 || !map[item.parentId]) {
            tree.push(node)
          }
        }
      })

      const sortFunc = (a, b) => a.sort.parsedValue - b.sort.parsedValue
      tree.sort(sortFunc)
      const sortChildren = (nodes) => {
        nodes.forEach(node => {
          if (node.children && node.children.length > 0) {
            node.children.sort(sortFunc)
            sortChildren(node.children)
          }
        })
      }
      sortChildren(tree)

      return tree
    },
    GetNote(urlSlug) {
      if (this.$route.query.urlSlug !== urlSlug) {
        this.$Common.SetLoading('正在载入 Markdown 组件包, 请稍候...')
        this.$router.push('/Index/Note?urlSlug=' + urlSlug).then(() => {
          this.$Common.RemoveLoading()
        })
      }
    },
    CleanSearch() {
      this.filter.search = ''
      this.$nextTick(() => { this.GetDocTree() })
    },
    HandleRecycleBinDragOver(event) {
      this.isDragOverRecycleBin = true
      event.dataTransfer.dropEffect = 'move'
    },
    HandleRecycleBinDrop(event) {
      this.isDragOverRecycleBin = false
      const nodeId = event.dataTransfer.getData('nodeId')
      if (nodeId) {
        // 查找节点名称用于提示
        const findNodeName = (nodes, id) => {
          for (const node of nodes) {
            if (node.id == id) return node.nodeName
            if (node.children) {
              const found = findNodeName(node.children, id)
              if (found) return found
            }
          }
          return ''
        }
        
        const nodeName = findNodeName(this.fileList, nodeId)
        
        this.$emit('show-dialog', {
          title: '删除警告',
          content: '你正在删除 [' + nodeName + '], 删除后的节点会放入回收站，在30天内可恢复，是否继续?',
          icon: '/icon/warning.svg',
          buttonName: { accept: '继续删除', cancel: '再想想' },
          accept: () => { this.RemoveDocNode(nodeId) }
        })
      }
    }
  }
}
</script>

<style scoped>
  .FileManager {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }
  
  .FileList {
    flex: 1;
    position: relative;
    height: 0; /* Flexbox hack for scrolling */
  }

  .RecycleBinEntry {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    background: #f9f9f9;
    color: var(--ccs-primary-font-color);
    display: flex;
    align-items: center;
    padding-left: 20px;
    cursor: pointer;
    border-top: 1px solid #eee;
    z-index: 10;
  }

  .RecycleBinEntry:hover {
    background: #f0f0f0;
    color: var(--ccs-primary-color);
  }

  .RecycleBinEntry_DragOver {
    background: #ffe6e6 !important;
    color: #e2696c !important;
    border: 2px dashed #e2696c;
  }

  .Search {
    --padding: 10px;
    position: absolute;
    top: 0;
    width: 100%;
    padding: var(--padding);
    box-sizing: border-box;
  }
  .Search .Input {
    --padding: 15px;
    width: 100%;
    height: 30px;
    border: 0;
    padding: 2px var(--padding);
    border-radius: calc(var(--padding) * 2);
    background: unset;
    text-align: center;
    background: #fff;
    color: var(--ccs-primary-font-color);
    box-shadow: none;
    border: 1px solid #eee;
    box-sizing: border-box;
  }
  .Search .Input:focus-visible {
    outline: 1px solid var(--ccs-primary-color);
    background: #fff;
  }
  .Search .SidebarAction {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
  }
  .Search .SidebarAction .ActionItem {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48%;
    height: 30px;
    background: #fff;
    border-radius: 15px;
    font-size: 12px;
    color: var(--ccs-primary-font-color);
    cursor: pointer;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border: 1px solid #eee;
    transition: all 0.2s;
  }
  .Search .SidebarAction .ActionItem:hover {
    color: var(--ccs-primary-color);
    box-shadow: 0 2px 5px rgba(0,0,0,0.15);
    background: #f9f9f9;
  }
  .Search .SidebarAction .ActionItem span {
    padding-left: 5px;
  }
  .FileList {
    position: absolute;
    top: 94px; /* match --searchHeight */
    width: 100%;
    height: calc(100% - 94px);
    overflow-y: auto;
  }
</style>
